<template>
	<Modal full footerFixed classNames="consent_modal" v-if="isAgree" @close="doLogout">
		<template v-slot:header>
			약관개정 동의 ({{ currentPage }} / {{ totalCount }})
			<strong class="txt_red">(필수)</strong>
		</template>
		<div class="wrap">
			<p v-html="termsPopupList[0].termsDesc"></p>
		</div>
		<template v-slot:footer>
			<button type="button" class="btn lg black" @click="doLogout">
				<span class="txt">거부</span>
			</button>
			<button type="button" class="btn lg red" @click="agreeTerms">
				<span class="txt">동의</span>
			</button>
		</template>
	</Modal>
</template>

<script>
import AlarmMsg from '@/utils/alarmMsg';
import Modal from '@/components/common/Modal';
import { mapGetters } from 'vuex';
import { getTermsPopupList, agreeTermsPopup } from '@/api/main/main';

export default {
	name: 'TermsReAgreePopup',

	components: {
		Modal,
	},

	data() {
		return {
			termsPopupList: [],
			totalCount: 0,
			currentPage: 0,
		};
	},

	computed: {
		...mapGetters(['userInfo', 'isLoggedIn', 'termsList']),

		isAgree() {
			if (this.$route.name === 'login') return false;

			if (this.termsList.length) this.updateList();

			// 로그인 & 마스터 회원 & 회원상태: ACT(이용 중) & BO 팝업 공개 여부: Y
			if (
				this.isLoggedIn &&
				this.userInfo?.masterYn === 'Y' &&
				this.userInfo?.userStts === 'ACT' &&
				this.termsPopupList.length
			) {
				return true;
			}
			return false;
		},
	},

	created() {
		this.init();
	},
	destroyed() {
		// 팝업 종료 시 현재 페이지 count 노출 초기화
		this.currentPage = 1;
	},

	methods: {
		init() {
			this.getTermsPopupList();
		},
		// 약관 동의 팝업 목록 조회
		getTermsPopupList() {
			getTermsPopupList({})
				.then(response => {
					if (response.code === 'SUC0000') {
						this.termsPopupList = response.result.termsPopupList;
						this.totalCount = response.result.termsPopupList.length;
						this.currentPage = 1;
					}
				})
				.catch(error => {
					console.error('[getTermsPopupList]', error);
				});
		},
		// 약관 동의 이력 저장
		agreeTermsPopup(agreeYn) {
			const params = {
				termsSeq: this.termsPopupList[0].termsSeq,
				agreeYn: agreeYn,
			};
			agreeTermsPopup(params)
				.then(response => {
					if (response.code === 'SUC0000') {
						if (agreeYn === 'Y') {
							this.termsPopupList.splice(0, 1);
							this.currentPage++;

							// 마지막 재동의 팝업인 경우, api 실행시켜 남은 팝업이 있는지 확인
							if (!this.termsPopupList.length) {
								this.getTermsPopupList();
							}
						} else {
							this.$store
								.dispatch('LogoutStay')
								.then(() => {
									AlarmMsg.showMsg(
										'약관에 거부하여 로그아웃 되었습니다. 이용을 원하실 경우 로그인을 다시 진행해주세요.'
									).then(() => {
										if (this.$route.path !== '/home') location.replace('/home');
									});
								})
								.catch(() => {
									console.error('Error during logout due to token expiration');
								});
						}
					}
				})
				.catch(error => {
					console.error('[agreeTermsPopup]', error);
				});
		},
		agreeTerms() {
			this.agreeTermsPopup('Y');
		},
		doLogout() {
			this.agreeTermsPopup('N');
		},
		updateList() {
			this.termsPopupList = this.termsList;

			// 최초 진입 시 totalcount 0인 경우에 값 set.
			if (this.totalCount < this.termsList.length) {
				this.totalCount = this.termsList.length;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.consent_modal {
	.wrap {
		&::v-deep table {
			colgroup > * {
				width: auto !important;
			}
			tr > * {
				width: auto !important;
				border-left: 1px solid #dadada;
			}
		}
	}
}
</style>
